// middleware/auth.global.ts
import { useAuthStore } from '~/store/auth'

export default defineNuxtRouteMiddleware(async () => {
	const config = useRuntimeConfig()
	const auth = useAuthStore()
	const tokenCookie = useCookie<string | null>(config.public.auth.name_cookie)

	const token = tokenCookie.value
	if (!token) return

	// 1) hidrata token en store (SSR y Client)
	if (auth.token !== token) auth.ADD_TOKEN(token)

	// 2) si ya tienes user, no pegues a /me
	if (auth.user) return

	// 3) evita duplicados (mejor usar useState porque en SSR hay requests separados)
	const fetching = useState<boolean>('fetchingMe', () => false)
	if (fetching.value) return
	fetching.value = true

	try {
		const res = await auth.fetchMe()

		const statusCode = res?.statusCode ?? res?.data?.statusCode
		const isUnauthorized = statusCode === 401 || statusCode === 403

		if (isUnauthorized) {
			await auth.REMOVE_TOKEN()
			tokenCookie.value = null
		}
	} finally {
		fetching.value = false
	}
})
